// Tab functions
function tabClick(clickedTab) {
    removeActiveClass();
    addActiveClass(clickedTab.dataset.target);
    updateDropdownValue(clickedTab.dataset.target);
    changeVideos(clickedTab.dataset.target);
}

function addActiveClass(target) {
    document.querySelector("[data-target='" + target + "']").classList.add('active');
}

function removeActiveClass() {
    document.querySelector('p.tabs-item.active').classList.remove('active');
}

function updateDropdownValue(newValue) {
    document.querySelector("#tab-options").value = newValue;
}

function changeVideos(tabValue) {
    let visibleContainer = document.querySelector("[data-id='" + tabValue + "']");

    if (visibleContainer) {
        document.querySelector('.visible').classList.remove("visible");
        visibleContainer.classList.add("visible");
    }
}